module.exports = function() {
  return new Worker(__webpack_public_path__ + "8e333635301b7936d0f2.worker.js");
};